import { useEffect, useState } from "react";
import { fetchJSONFromGZFile } from "@ipru-common/utils/QuoteCommonFunctions";

const useBlackListedList = () => {
  const [blacklistedContacts, setBlacklistedContacts] = useState();
  const fetchBlackListedList = async () => {
    try {
      const jsonData = await fetchJSONFromGZFile("blacklisted_contacts");
      if (jsonData) {
        setBlacklistedContacts(jsonData);
      } else {
        console.error("Fail to fetch");
        return null;
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchBlackListedList();
  }, []);

  return { blacklistedContacts };
};

export default useBlackListedList;
